export default class Locale_CountDownDialog { 
	IKnowWhatImDoing: string = "I know what I'm doing";
	Cancel: string = "Cancel";
}